import { useRouter } from "next/router";
import { cx } from "@nju/css";
import { RegistrationForm } from "./RegistrationForm";

export function RegistrationPage() {
  const router = useRouter();
  const hasOffer = !!router.query.oferta;

  return (
    <div
      className={cx("from-tablet:flex from-tablet:justify-center", {
        "block justify-start": hasOffer,
      })}
    >
      <div
        className={cx("flex-col from-tablet:inline-flex", {
          "from-tablet:flex": hasOffer,
        })}
      >
        <RegistrationForm />
      </div>
    </div>
  );
}
